export default __webpack_public_path__ + "components/landing-page/cards/shared/indigo-press/pb-indicator.png";